/* ------------------------------------------------------------
*** Theme Swiper — Lenis / ScrollTrigger sync + rail defaults
------------------------------------------------------------
  Load after swiper-bundle, before global.js.

  • notifyLayoutChange() — after Swiper init or DOM height changes
    (coalesced to one rAF).

  • registerStaticDomRail(swiperName) — Liquid swiperName values
    with fully server-rendered slides (skip Swiper MutationObserver).

  • shouldObserveSlideMutations(swiperName) — used by
    swiper-component; false for static rails.
------------------------------------------------------------ */

class ThemeSwiper {
  constructor() {
    this._layoutNotifyRafId = null;

    this._staticDomRailNames = new Set([
      "carousel",
      "featured-products",
      "featured-blogs",
      "featured-collections"
    ]);
  }

  notifyLayoutChange() {
    if (this._layoutNotifyRafId !== null) {
      return;
    }

    this._layoutNotifyRafId = requestAnimationFrame(() => {
      this.handleLayoutAnimationFrame();
    });
  }

  registerStaticDomRail(name) {
    if (!name || typeof name !== "string") {
      return;
    }

    this._staticDomRailNames.add(name);
  }

  shouldObserveSlideMutations(swiperName) {
    if (!swiperName) {
      return true;
    }

    return !this._staticDomRailNames.has(swiperName);
  }

  handleLayoutAnimationFrame() {
    this._layoutNotifyRafId = null;

    const lenis = window.themeLenis?.lenis;

    if (lenis && typeof lenis.resize === "function") {
      lenis.resize();
    }

    if (typeof ScrollTrigger !== "undefined") {
      ScrollTrigger.refresh();
    }
  }
}

const themeSwiper = new ThemeSwiper();

window.themeSwiper = themeSwiper;

window.notifyThemeScrollLayoutChange = () => {
  themeSwiper.notifyLayoutChange();
};
